import React from 'react'
import Container from '@material-ui/core/Container'
import Paper from '@material-ui/core/Paper'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import LinearProgress from '@material-ui/core/LinearProgress'
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined'
import { STRIPE_CUSTOMER_PORTAL_URL } from 'env'
import pgaCoachPlusLogo from 'images/pga-coach-plus-logo.svg'
import pgaCoachLogo from 'images/pga-coach-logo.png'
import { useUpgradeFlow } from 'lib/hooks/use-upgrade-flow'
import UpgradeSuccessModal from 'components/upgrade-success-modal'

const SubscriptionDetails = () => {
  const {
    hasPaidTier: hasPaidTierSubscription,
    showSuccessModal,
    upgradeLoading: loading,
    handleUpgradeClick,
    handleDismiss,
  } = useUpgradeFlow('subscription-details')

  return (
    <>
      <Box my={6}>
        <Container maxWidth="md" component={Paper} variant="outlined">
          {loading && <LinearProgress />}
          {hasPaidTierSubscription ? (
            <Box
              display="flex"
              justifyContent="space-between"
              px={[1, 6]}
              py={[1, 4]}
            >
              <Box display="flex" flexDirection="column">
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ marginBottom: '8px', marginLeft: '2px' }}
                >
                  Your Plan
                </Typography>
                <img
                  src={pgaCoachPlusLogo}
                  alt="PGA Coach Plus logo"
                  style={{ height: '22px' }}
                />
              </Box>
              <Button
                startIcon={<OpenInNewOutlinedIcon />}
                variant="outlined"
                color="primary"
                target="_blank"
                href={STRIPE_CUSTOMER_PORTAL_URL}
              >
                Manage Plan
              </Button>
            </Box>
          ) : (
            <Box
              display="flex"
              justifyContent="space-between"
              px={[1, 6]}
              py={[1, 4]}
            >
              <Box display="flex" flexDirection="column">
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ marginBottom: '8px' }}
                >
                  Your Plan
                </Typography>
                <img
                  src={pgaCoachLogo}
                  alt="PGA Coach logo"
                  style={{ height: '30px' }}
                />
              </Box>
              <Button
                startIcon={<OpenInNewOutlinedIcon />}
                variant="outlined"
                color="primary"
                onClick={handleUpgradeClick}
              >
                Upgrade Now
              </Button>
            </Box>
          )}
        </Container>
      </Box>

      <UpgradeSuccessModal isOpen={showSuccessModal} onClose={handleDismiss} />
    </>
  )
}

export default SubscriptionDetails
